/**
 * Source of the interview flow. Used to decide where to redirect on cancel/logout.
 * Read from query param `source` when entering /interview (default: Booth).
 */
export enum InterviewSource {
  Booth = 'Booth',
  Dashboard = 'Dashboard',
}

const SOURCE_QUERY_PARAM = 'source';

/**
 * Parses interview source from URL search params. Defaults to Booth when missing or invalid.
 */
export function parseInterviewSourceFromSearch(search: string): InterviewSource {
  const params = new URLSearchParams(search);
  const value = params.get(SOURCE_QUERY_PARAM);
  if (value === InterviewSource.Dashboard) {
    return InterviewSource.Dashboard;
  }
  return InterviewSource.Booth;
}
